import React from "react";

export const works: {
  dates: string | JSX.Element;
  name: string;
  technologies: string[];
  description?: string;
  position?: string;
}[] = [
  {
    dates: (
      <div>
        2020/3 - 2020/12 <b className="font-bold">(9 months)</b>
      </div>
    ),
    name: "Purple Technology",
    position: "Senior Fullstack developer",
    technologies: [
      "React",
      "Typescript",
      "GraphQL",
      "AWS",
      "Serverless",
      "Step functions",
      "DynamoDB"
    ]
  },
  {
    dates: (
      <div>
        2019/2 - 2019/10 <b className="font-bold">(8 months)</b>
      </div>
    ),
    name: "Kickresume",
    position: "React developer",
    technologies: ["React", "Typescript", "GraphQL"]
  },
  {
    name: "MyPIO",
    position: "Medior Fullstack developer",
    dates: (
      <div>
        2018/7 - 2019/2 <b className="font-bold">(8 months)</b>
      </div>
    ),
    technologies: ["React", "Redux", "Node.js", "Express"]
  },
  {
    name: "Domotherm s.r.o",
    position: "Lead frontend developer",
    dates: (
      <div>
        2017/6 - 2017/12 <b className="font-bold">(6 months)</b>
      </div>
    ),
    description: "",
    technologies: ["React", "Redux"]
  },
  {
    name: "Fleetlog",
    position: "Junior React developer",
    dates: (
      <div>
        2016/7 - 2016/9 <b className="font-bold">(2 months)</b>
      </div>
    ),
    description: "",
    technologies: ["React"]
  },
  {
    name: "Profitcomputing s.r.o",
    dates: (
      <div>
        2015/6 - 2015/8 <b className="font-bold">(2 months)</b>
      </div>
    ),
    description: "",
    technologies: ["Javascript", "php"]
  },
  {
    name: "Small jobs through agencies",
    dates: <div>2014 - 2015/6</div>,
    description:
      "Helping with moving furniture, cleaning the floor, painting a fence",
    technologies: []
  }
];
